export const INDEX_DESIGN_ORDER = 'index-design-order';
export const INDEX_DESIGN_REF = 'index-design-ref';
export const INDEX_DESIGN_PARENT = 'index-design-parent';
export const INDEX_DESIGN_ROOT = 'index-design-root';

export const SORT_AND_USE_INDEX = {
  fields: ['parent', 'order'],
  index: INDEX_DESIGN_ORDER,
};
